export const HERO_MEDIA_HEIGHT_DESKTOP = '312px';
export const HERO_MEDIA_HEIGHT_MOBILE = '280px';
export const MIN_HERO_SECTION_HEIGHT = '360px';